<div class="ui-sumary">
    <div class="ui-sumary-header">
        <div class="ui-sumary-header-container">
            <div class="ui-resume">
                <div class="ui-resume-title">
                    <h1>¡Bienvenido {{user.firstnameUnique(0)}}!</h1> <span class="el-status">{{accountStatus(user.status)}}</span>
                </div>
                
                <ul>
                    <li><strong>Cuenta:</strong> {{user.client}}</li>
                    <li><strong>Domicilio:</strong> {{user.addressName}}</li>
                    <li><strong>Linea:</strong> {{user.phone}}</li>
                    <li><strong>Correo electrónico:</strong> {{user.email}}</li>
                    <li *ngIf="user.debitIsSet()">Esta cuenta está adherida a débito automático mediante <strong>{{ (user.debitGetType() == 'credit')? 'Tarjeta de crédito' : 'CBU' }}</strong></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="ui-sumary-body">
        <div class="ui-sumary-side">
            <div class="ui-invoices ui-shadow">
                <div class="ui-invoices-balance">
                    <div class="ui-balance">
                        <div class="ui-balance-amount">
                            <h1><small>$</small> {{user.balance.total}}</h1>
                            <span *ngIf="user.balance.status">Balance de la cuenta</span>
                            <span *ngIf="!user.balance.status">Total pendiente de pago</span>
                        </div>
                        <div class="ui-balance-status" [class]="{'success': user.balance.status, 'error': !user.balance.status}">
                            <span *ngIf="user.balance.status">Cuenta al día</span>
                            <span *ngIf="!user.balance.status">Saldo impago</span>
                        </div>
                    </div>

                    <button mat-flat-button color="primary" class="ui-button" (click)="onPaymentAll()" *ngIf="!user.balance.status && user.isPaymentStatus()">Realizar pago</button>   
                </div>

                <ul class="ui-invoices-action">
                    <li><a (click)="onReportPayment()"><span>Reportar un pago</span><mat-icon>chat</mat-icon></a></li>
                    <li><a (click)="onDownloadLastInvoice()"><span>Descargar última factura</span><mat-icon>get_app</mat-icon></a></li>
                    <li><a (click)="onMyBills()"><span>Mis facturas</span><mat-icon>receipt</mat-icon></a></li>
                </ul>
            </div>

            <app-accounts-messages [messages]="user.messages"></app-accounts-messages>
        
            <div class="ui-actions">
                <app-procedures-buttons [class]="'ui-sumary-actions'"></app-procedures-buttons>
            </div>
        </div>
        
        <div class="ui-sumary-content">
            <app-accounts-messages [messages]="user.messages"></app-accounts-messages>

            <app-procedures-list></app-procedures-list>
        </div>
    </div> 
</div>